import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectWithoutProperties.js";
import n from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectSpread2.js";
import * as r from "react";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/primitives/input.tsx
var a = ["className", "type"], o = r.forwardRef((r, o) => {
	let { className: s, type: c = "text" } = r, l = t(r, a);
	return /* @__PURE__ */ i("input", n({
		type: c,
		ref: o,
		"data-slot": "input",
		className: e("flex h-9 w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm", "file:border-0 file:bg-transparent file:text-sm file:font-medium", "placeholder:text-muted-foreground", "focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 focus:outline-none", "disabled:cursor-not-allowed disabled:opacity-50", "aria-[invalid=true]:border-red-500 aria-[invalid=true]:focus:ring-red-500/20", s)
	}, l));
});
o.displayName = "Input";
//#endregion
export { o as Input };

//# sourceMappingURL=input.js.map